<mat-radio-group
  aria-label="選択して下さい"
  [formControl]="control"
  class="radio-list"
>
  <mat-radio-button
    *ngFor="let alias of aliasList"
    [value]="alias.id"
    [checked]="isChecked(alias)"
    disableRipple
  >
    {{ alias.name }}
  </mat-radio-button>
</mat-radio-group>
